// extracted by mini-css-extract-plugin
export var privacy = "Privacy-module--privacy--cc0c8";
export var privacyContent = "Privacy-module--privacyContent--6fe25";